export const nonInverseRelationshipTypes = [
  'spouse',
  'partner',
  'sibling',
  'twin',
  'friend',
  'colleague',
  'coworker',
  'family',
  'teammate',
  'neighbor',
  'acquaintance',
  'classmate',
  'roommate',
];
